<template>
  <div class="flex items-center justify-center gap-3 py-12">
    <div class="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    <span v-if="message" class="text-sm text-muted-foreground">{{ message }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps({
  message: { type: String, default: 'Loading...' },
})
</script>
